import React from "react";
import PeerToPeer from "../../images/social-iaamarketplace/peer.svg";
import BetterROI from "../../images/social-iaamarketplace/return-on-investment.svg";
import RaiseCapital from "../../images/social-iaamarketplace/capital.svg";
import LiveMonitoring from "../../images/social-iaamarketplace/live-monitoring.svg";

import { Row, Col } from "react-bootstrap";
import BenefitsCard from "../BenefitsCard/BenefitsCard";
import { Container } from "@material-ui/core";

export default function SolutionMarketplaceFeatures() {
  const benefits = [

   
     
    {
      img: PeerToPeer,
      title: "CloudGateway",
      bodycopy:
      "CloudGateway allows seamless integration of cloud-based services for SI partners, enabling secure data exchange and operational scalability within the Solution Marketplace.",
    },
    {
        img: BetterROI,
        title: "DeviceCloudServer",
        bodycopy: " DeviceCloudServer offers centralized management of IoT devices and cloud connectivity for SI partners, enhancing operational efficiency in the Solution Marketplace."    },
     

        {
          img: RaiseCapital,
          title: "Vertical Edge Server",
          bodycopy: " Vertical Edge Server provides localized computing and data processing at the network edge, reducing latency and enhancing real-time decision-making within the Solution Marketplace.  "    },
 
          {
            img: LiveMonitoring,
            title: "Vertical Use Case",
            bodycopy: " Vertical Use Case enables industry-specific solutions tailored to the unique needs of SI partners, optimizing workflows and performance within the Solution Marketplace."    },
       
            {
              img: LiveMonitoring,
              title: "Point Solutions",
              bodycopy: " Point Solutions are specialized tools within the Solution Marketplace designed to address specific, narrowly focused problems or needs in  operations, offering targeted functionality and efficiency."    },
       
              {
                img: LiveMonitoring,
                title: "AI/ML App",
                bodycopy: " The AI/ML App leverages artificial intelligence and machine learning algorithms to analyze data, predict trends, and optimize processes, enhancing decision-making and operational efficiency within the Solution Marketplace."    },
          ];
  return (
    <div className="">
          <Container className="subSectionWrapper ">
      <h2 className="text-center container-title mb-4">
          Features
      </h2>
      <Row>
        {benefits.map((e,index) => {
          return (
            <Col md={4} className="d-flex" key={index}>
              <BenefitsCard src={e.img} title={e.title} bodycopy={e.bodycopy} />
            </Col>
          );
        })}
      </Row>
      </Container>
    </div>
  );
}
